import run from "../../animate/run";

/**
 * Click
 * @param {CustomEventProps} event
 */
const click = (event) => {
  const trigger = /** @type {TriggerProps} */ (event.details?.get("trigger"));
  const parameters = /** @type {TriggerParametersProps & Map<String, any>} */ (
    trigger.get("parameters")
  );
  const toggle = parameters?.get("toggle")?.get("v_output");
  const enter = trigger.get("mode") !== "enter";

  if (toggle) {
    run(event, enter ? "enter" : "leave", enter);
  } else {
    run(event, "enter", true);
  }
};

export default click;
